import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ticket-dialog',
  templateUrl: './ticket-dialog.component.html',
})
export class TicketDialogComponent implements OnInit {

  form: FormGroup;
  files: File[] = [];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TicketDialogComponent>,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      descrizione: ['', Validators.required],
    });
  }

  onFilesSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files) {
      for (let i = 0; i < input.files.length; i++) {
        this.files.push(input.files[i]);
      }
      input.value = '';
    }
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  submit() {
    if (this.form.valid) {
      this.dialogRef.close({ ...this.form.value, _files: this.files });
    }
  }
}
